import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import PcSelect from './PcSelect';

const SelectInput = ({
    dispatch,
    isLoading,
    input,
    meta = {},
    label,
    required,
    options,
    style,
    disabled,
    compact,
    showValue,
    searchable,
    searchPlaceholder,
    placeholder,
    allowEmpty,
    emptyLabel,
    mono,
    disablePortal,
}) => {
    const inputProps = input || {};
    const { touched, error } = meta;
    const list = (options && Array.isArray(options) ? options : []).filter(Boolean).map((item) => ({
        ...item,
        login: showValue ? (item.id || item._id) : item.login,
    }));

    return (
        <div className={`pc-field${compact ? ' pc-field--compact' : ''}${mono ? ' pc-field--mono' : ''}`} style={style}>
            {label ? (
                <label className="pc-field__label">
                    {label}
                    {required ? <i>*</i> : null}
                </label>
            ) : null}
            <PcSelect
                value={inputProps.value || ''}
                onChange={(event) => inputProps.onChange(event.target.value)}
                onBlur={inputProps.onBlur}
                options={list}
                disabled={disabled || (isLoading && !list.length)}
                searchable={searchable}
                searchPlaceholder={searchPlaceholder}
                placeholder={placeholder || 'Не указано'}
                disablePortal={disablePortal}
                allowEmpty={allowEmpty}
                emptyLabel={emptyLabel}
                mono={mono}
                className={touched && error ? 'is-invalid' : ''}
            />
            {touched && error ? <em className="pc-field__hint is-err">{error}</em> : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    const { fetch } = state;
    return {
        isLoading: !!fetch.loading,
    };
};

export default compose(
    connect(mapStateToProps),
)(SelectInput);
